"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../store/store");
const StatisticsRow_1 = __importDefault(require("../../components/StatisticsRow/StatisticsRow"));
const MyDonationStats = ({ donorData }) => {
    const { appSettings } = (0, store_1.useAppSelector)((state) => state.app);
    const { hideUnitPrefixInDonationStats } = appSettings || {};
    const boxes = donorData === null || donorData === void 0 ? void 0 : donorData.donationStats.map((box) => {
        return Object.assign(Object.assign({}, box), { showUnit: !hideUnitPrefixInDonationStats });
    });
    const showAtleastOne = donorData === null || donorData === void 0 ? void 0 : donorData.donationStats.some(({ show }) => show);
    return showAtleastOne ? ((0, jsx_runtime_1.jsxs)("div", { className: "my-donation-stats", children: [(0, jsx_runtime_1.jsx)("h5", { children: __.trans('donation.my-blood-donation') }), (0, jsx_runtime_1.jsx)(StatisticsRow_1.default, { boxes: boxes })] })) : null;
};
exports.default = MyDonationStats;
